import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnitSelectionFilterComponent } from './unit-selection-filter.component';
import { UnitSelectorModule } from 'app/components/app-layout/shared/unit-selector/unit-selector.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        UnitSelectorModule,
        MatIconModule,
    ],
    declarations: [UnitSelectionFilterComponent],
    exports: [UnitSelectionFilterComponent],
})
export class UnitSelectionFilterModule
{
}
